export enum FacetTypes {
    Multiselect = 'multiselect',
    Singleselect = 'singleselect',
}
